import { render, staticRenderFns } from "./walletAddress.vue?vue&type=template&id=e2952f86&scoped=true"
import script from "./walletAddress.vue?vue&type=script&lang=js"
export * from "./walletAddress.vue?vue&type=script&lang=js"
import style0 from "./walletAddress.vue?vue&type=style&index=0&id=e2952f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2952f86",
  null
  
)

export default component.exports